import { IPriceFilteringRuleStoreSegment } from './priceFilteringRule.interface';

export const priceFilteringRuleStoreSelector = (state: IPriceFilteringRuleStoreSegment) => state.priceFilteringRule;
